import { ShieldAlert } from "lucide-react";
import { useAuth } from "../lib/auth";

/**
 * QA KY-08: when a verified member changes their legal name, the account stays
 * verified but the change is queued for admin re-review. This slim banner makes
 * that pending state visible to the member (admins are notified separately).
 */
export function IdentityReviewBanner() {
  const { user } = useAuth();
  if (!user || !user.identityReviewPending || user.userType === "admin") return null;

  return (
    <div className="bg-sky-50 border-b border-sky-200">
      <div className="container-x py-2 flex items-center gap-3 text-sm text-sky-900">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <div className="flex-1 min-w-0">
          Your legal name change is under review. Your verified status stays active while our team confirms the update — no action needed.
        </div>
      </div>
    </div>
  );
}
